import React from 'react';

import {Paper, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const TitleCard = () => {
  return (
    <Paper sx={{padding: '24px', borderRadius: '20px', boxShadow: 'none'}}>
      <Stack sx={{gap: '20px'}}>
        <Typography sx={{fontSize: '32px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          <Translate expression={'careplanstep.TitleCard.Title'} />
        </Typography>
        <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
          <Translate expression={'careplanstep.TitleCard.Description'} />
        </Typography>
      </Stack>
    </Paper>
  );
};

export default React.memo(TitleCard);
